import React from 'react';
import { Link } from 'react-router-dom';

const AwardeeGridCard = ({ awardee }) => {
  return (
    <Link to={`/awards/${awardee.id}`} className="block">
      <article className="overflow-hidden rounded-2xl bg-white shadow-md transition-transform duration-200 hover:-translate-y-1 hover:shadow-lg">
        <img
          src={awardee.image}
          alt={awardee.imageAlt}
          className="aspect-[3/4] w-full object-cover"
        />
        <div className="p-5 text-center">
          <h3 className="text-xl font-semibold text-primary">
            {awardee.name}
          </h3>
          <span className="mt-4 inline-block rounded-full bg-primary px-5 py-2 text-sm font-medium text-white transition-colors duration-200 hover:bg-primary-dark">
            View Details
          </span>
        </div>
      </article>
    </Link>
  );
};

export default AwardeeGridCard;
